(function () {
  'use strict';

  var CART_MIN = 95;
  var CART_MAX = 168;
  var CART_UPDATE_MS = 3200;

  function calculateCartCheckoutCount() {
    var now = new Date();
    var hour = now.getHours();
    var dayOfWeek = now.getDay();
    var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    var base = 120;

    if (hour >= 0 && hour < 6) {
      base = isWeekend ? 102 : 98;
    } else if (hour >= 6 && hour < 10) {
      base = isWeekend ? 112 : 108;
    } else if (hour >= 10 && hour < 14) {
      base = isWeekend ? 138 : 128;
    } else if (hour >= 14 && hour < 18) {
      base = isWeekend ? 148 : 136;
    } else if (hour >= 18 && hour < 22) {
      base = isWeekend ? 158 : 146;
    } else {
      base = isWeekend ? 142 : 132;
    }

    var jitter = Math.floor(Math.random() * 11) - 5;
    return Math.max(CART_MIN, Math.min(CART_MAX, base + jitter));
  }

  function initCartProof(root) {
    if (!root || root.getAttribute('data-wccp-init') === '1') return;

    root.setAttribute('data-wccp-init', '1');

    var countEl = root.querySelector('[data-wccp-count]');
    if (!countEl) return;

    var currentCount = calculateCartCheckoutCount();
    countEl.textContent = String(currentCount);

    function updateCount() {
      var shouldIncrease = Math.random() > 0.4;
      var changeAmount = Math.floor(Math.random() * 3) + 1;

      if (shouldIncrease) {
        currentCount = Math.min(CART_MAX, currentCount + changeAmount);
      } else {
        currentCount = Math.max(CART_MIN, currentCount - changeAmount);
      }

      countEl.textContent = String(currentCount);
    }

    window.setInterval(updateCount, CART_UPDATE_MS);
  }

  function initAll() {
    document.querySelectorAll('[data-wccp-counter]').forEach(initCartProof);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('cart:updated', initAll);
  document.addEventListener('cart-drawer:updated', initAll);

  // Cart drawer content is often replaced via AJAX — re-bind new banners
  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        initAll();
      });
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
